import React, { useEffect, useState } from "react";
import auditService from "../../services/owner-services/owner-property-audit";
import { Card } from "react-bootstrap";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";

const tabOptions = [
  { label: "Building Pictures", auditType: "Building Pictures" },
  { label: "Water Tanker Pictures", auditType: "Water Tanker" },
  { label: "Payments Pictures", auditType: "Payments" },
];

const AuditTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [selectedImages, setSelectedImages] = useState([]);
  // const [showModal, setShowModal] = useState(false);
  const [selectedTab, setSelectedTab] = useState(tabOptions[0].label);
  const [imageMap, setImageMap] = useState({});

  useEffect(() => {
    const currentTab = tabOptions.find((tab) => tab.label === selectedTab);
    fetchAuditData(currentTab.auditType);
  }, [selectedTab]);

  const fetchAuditData = async (type) => {
    setLoading(true);
    try {
      const payload = {
        pageSize: 100,
        pageNo: 1,
        fromDate: "",
        toDate: "",
        filterParam: "",
        auditType: type,
      };
      const response = await auditService.posttPropertyAudit(payload);

      if (response.data.isSuccess) {
        const result = response.data.result;
        if (type === "Building Pictures") {
          // Fetch and map images separately for Building Pictures
          const galleryMap = {};
          await Promise.all(
            result.map(async (item) => {
              const res = await auditService.getPropertyAuditImage(item.id);
              galleryMap[item.id] =
                res.data.isSuccess && res.data.result.gallery
                  ? res.data.result.gallery
                  : [];
            }),
          );
          setImageMap(galleryMap);
          setData(result);
        } else {
          // Water Tanker / Payments → attach images directly
          const updatedResult = await Promise.all(
            result.map(async (item) => {
              const res = await auditService.getPropertyAuditImage(item.id);
              return {
                ...item,
                imageList:
                  res.data.isSuccess && res.data.result.gallery
                    ? res.data.result.gallery
                    : [],
              };
            }),
          );
          setData(updatedResult);
        }
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
    setLoading(false);
  };

  const formatDated = (dateString) => {
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return new Date(dateString)
      .toLocaleDateString("en-GB", options)
      .replace(/ /g, "-");
  };

  //no need this function directly handled by the  photoprovider
  // const openImageViewer = (images) => {
  //   setSelectedImages(images);
  //   setShowModal(true);
  // };

  //  Unified Card Renderer for all tabs
  // const renderImageCards = () => {
  //   return (
  //     <div className="row">
  //       {data.map((item) => {
  //         const images =
  //           selectedTab === "Building Pictures"
  //             ? imageMap[item.id] || []
  //             : item.imageList || [];

  //         return (
  //           <div key={item.id} className="col-md-12 mb-3">
  //             <Card>
  //               <Card.Body>
  //                 <Card.Title>
  //                   {item.propertyName}{" "}
  //                   {item.flatNo && <span>- Flat {item.flatNo}</span>} :{" "}
  //                   <span className="text-primary">
  //                     {formatDated(item.addedOn)}
  //                   </span>
  //                 </Card.Title>

  //                 {/* Thumbnails */}
  //                 <div className="gallery-images mb-2">
  //                   {images.length > 0 ? (
  //                     images.map((img) => (
  //                       <img
  //                         key={img.id}
  //                         src={img.fileLink}
  //                         alt="Audit"
  //                         style={{
  //                           width: "120px",
  //                           height: "120px",
  //                           objectFit: "cover",
  //                           margin: "4px",
  //                           cursor: "pointer",
  //                         }}
  //                         className="rounded"
  //                         onClick={() => openImageViewer(images)}
  //                       />
  //                     ))
  //                   ) : (
  //                     <p className="text-muted">No images found</p>
  //                   )}
  //                 </div>

  //                 {/* Comments */}
  //                 {item.comments && (
  //                   <div className="mt-2">
  //                     <b>Comments:</b>
  //                     <p>{item.comments}</p>
  //                   </div>
  //                 )}
  //               </Card.Body>
  //             </Card>
  //           </div>
  //         );
  //       })}
  //     </div>
  //   );
  // };
  const renderImageCards = () => {
    return (
      <div className="row">
        {data.map((item) => {
          const images =
            selectedTab === "Building Pictures"
              ? imageMap[item.id] || []
              : item.imageList || [];

          return (
            <div key={item.id} className="col-md-12 mb-3">
              <Card>
                <Card.Body>
                  <Card.Title>
                    {item.propertyName}{" "}
                    {item.flatNo && <span>- Flat {item.flatNo}</span>} :{" "}
                    <span className="text-primary">
                      {formatDated(item.addedOn)}
                    </span>
                  </Card.Title>

                  <PhotoProvider
                    toolbarRender={({ onRotate, rotate }) => (
                      <div
                        style={{
                          display: "flex",
                          gap: "12px",
                          alignItems: "center",
                        }}
                      >
                        {/* left rotate */}
                        <svg
                          onClick={() => onRotate(rotate - 90)}
                          style={{
                            cursor: "pointer",
                            width: "24px",
                            height: "24px",
                            fill: "white",
                          }}
                          viewBox="0 0 24 24"
                        >
                          <path d="M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47zm1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z" />
                        </svg>

                        {/* right rotate */}
                        <svg
                          onClick={() => onRotate(rotate + 90)}
                          style={{
                            cursor: "pointer",
                            width: "24px",
                            height: "24px",
                            fill: "white",
                          }}
                          viewBox="0 0 24 24"
                        >
                          <path d="M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z" />
                        </svg>
                      </div>
                    )}
                  >
                    <div className="gallery-images mb-2">
                      {images.length > 0 ? (
                        images.map((img) => (
                          <PhotoView key={img.id} src={img.fileLink}>
                            <img
                              src={img.fileLink}
                              alt="Audit"
                              style={{
                                width: "120px",
                                height: "120px",
                                objectFit: "cover",
                                margin: "4px",
                                cursor: "pointer",
                              }}
                              className="rounded"
                            />
                          </PhotoView>
                        ))
                      ) : (
                        <p className="text-muted">No images found</p>
                      )}
                    </div>
                  </PhotoProvider>

                  {item.comments && (
                    <div className="mt-2">
                      <b>Comments:</b>
                      <p>{item.comments}</p>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div>
      <h3 className="mb-4">Photos</h3>

      {/* Tab Buttons */}
      <div
        style={{
          marginBottom: "16px",
          display: "flex",
          flexWrap: "wrap",
          gap: "8px",
        }}
      >
        {tabOptions.map((tab) => {
          const isActive = tab.label === selectedTab;
          return (
            <button
              key={tab.label}
              onClick={() => setSelectedTab(tab.label)}
              style={{
                borderRadius: "6px",
                padding: "4px 10px",
                fontSize: "12px",
                fontWeight: isActive ? "600" : "400",
                border: isActive ? "1px solid #ff385c" : "1px solid #ced4da",
                backgroundColor: isActive ? "#ff385c" : "white",
                color: isActive ? "white" : "#000",
                cursor: "pointer",
                transition: "all 0.2s ease-in-out",
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Tab Content */}
      <div>
        {loading ? (
          <div className="text-center py-5">
            <span className="spinner-border text-primary" role="status"></span>
            <p className="mt-3">Fetching audit data...</p>
          </div>
        ) : data.length === 0 ? (
          <div className="text-center py-5">
            <p className="text-muted">
              No audit records found for "{selectedTab}".
            </p>
          </div>
        ) : (
          renderImageCards()
        )}
      </div>

      {/* while rendering the image only it contains slider full view everything so no need of the  this modal and swiper */}
      {/* Modal with Swiper */}
      {/* <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Images</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Swiper
            modules={[Pagination]}
            pagination={{ clickable: true }}
            spaceBetween={10}
            slidesPerView={1}
            loop
          >
            {selectedImages.map((img) => (
              <SwiperSlide key={img.id}>
                <img
                  src={img.fileLink}
                  alt="Slide"
                  style={{
                    width: "100%",
                    height: "400px",
                    objectFit: "contain",
                  }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal> */}
    </div>
  );
};

export default AuditTable;
